export const BOOKING_STATUS = {
    'INPROGRESS': 0,
    'COMPLETED': 1,
    'CANCELLED': 2
}